<template>
  <div>
    <section v-show="sidebarCurrentPanel === 'style'" class="kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open">
      <div class="kp-modular-tab pt-page no-fade pt-page-current">
        <header class="kp-modular-title">
          {{ $t('general.labels.edition') }}
        </header>
        <div class="submenu-content sub-color">
          <modifiers-config></modifiers-config>
          <trigger-button-config></trigger-button-config>
          <a
            href="#"
            class="btn"
            v-show="boxConfig.advanced.view_mode === 'automatic'"
            @click="sidebarChangePanel('exibitionmode');sidebarChangeActiveButton('advancedconfig');canvasChangeView('preview');">{{ $t('edit.sidebar.configure_box') }}</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TriggerButtonConfig from './TriggerButton.vue';
import ModifiersConfig from './Modifiers.vue';

export default {
  components: {
    TriggerButtonConfig,
    ModifiersConfig,
  },
  computed: mapGetters({
    sidebarCurrentPanel: 'sidebarCurrentPanel',
    boxConfig: 'boxConfig',
  }),
  methods: mapActions([
    'sidebarChangePanel',
    'sidebarChangeActiveButton',
    'canvasChangeView',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?5b518262
 **/